import { Outlet } from "react-router-dom";
import type { Language } from "@/contexts/LanguageContext";

interface LangRouteProps {
  /**
   * Language that this route subtree represents. Not read at runtime
   * (actual sync lives in `<LanguageUrlSync />`) - kept as an explicit
   * annotation at the route definition so the routing table documents
   * itself.
   */
  lang: Language;
}

export const LangRoute = ({ lang: _lang }: LangRouteProps) => <Outlet />;

export default LangRoute;
